import Cookies from "universal-cookie";

const getTokenCookiesProperties = () => {
    const domain = process.env.REACT_APP_COOKIES_DOMAIN;
    const path = "/";
    return { domain, path };
}

export const setToken = (accessToken, strategy) => {
    const cookies = new Cookies();
    const properties = getTokenCookiesProperties();
    cookies.set(`vx.token.${strategy}`, accessToken, properties);
    cookies.set("vx.strategy", strategy, properties);
}

export const removeToken = () => {
    const cookies = new Cookies();
    const properties = getTokenCookiesProperties();
    cookies.remove("vx.strategy", properties);
    cookies.remove("vx.token.google", properties);
    cookies.remove("vx.token.facebook", properties);
    cookies.remove("vx.token.local", properties);
}

export const getToken = () => {
    try {
        const cookies = new Cookies();
        const strategy = cookies.get("vx.strategy");
        const token = cookies.get(`vx.token.${strategy}`);
        return token;
    } catch (error) {
        return null;
    }
}